import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(() => ({
  fontSize: 16,
  lineHeight: "22px",
  fontWeight: 500,
  px: 2,
  py: 1.5,
}));
